import { render, staticRenderFns } from "./pageTargetSplit.vue?vue&type=template&id=00c5af38&scoped=true"
import script from "./pageTargetSplit.vue?vue&type=script&lang=js"
export * from "./pageTargetSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5af38",
  null
  
)

export default component.exports